import React, { useState } from 'react';
import { useAppSelector } from 'store/hooks';

import { currentLessonSelector } from 'store/lesson/selectors';
import { currentCourseSelector } from 'store/course/selectors';

import { formatTasks } from './helpers/formatTasks';
import { getLessonsCount } from './FigmaLessonPreviewPage.helpers';

import FigmaLessonPreviewPage from './FigmaLessonPreviewPage';

const FigmaLessonPreviewPageContainer = () => {
  const lesson = useAppSelector(currentLessonSelector);
  const course = useAppSelector(currentCourseSelector);

  const [currentTasks] = useState(formatTasks(lesson.tasks));
  const [currentTaskIndex] = useState(0);
  const [previewExpanded, setPreviewExpanded] = useState(false);
  const [previewType, setPreviewType] = useState('Plugin');
  const [isTestMode, setTestMode] = useState(false);

  const handleExpandClick = () => {
    setPreviewExpanded(true);
  };

  const handleExitPreviewClick = () => {
    setPreviewExpanded(false);
  };

  const completed = currentTasks.every((task: any) => task.completed);

  return (
    <>
      <FigmaLessonPreviewPage
        completed={completed}
        previewExpanded={previewExpanded}
        currentTasks={currentTasks}
        currentTaskIndex={currentTaskIndex}
        lessonTitle={lesson.title}
        currentLesson={getLessonsCount(course, lesson).lessonIndex}
        lessonsCount={getLessonsCount(course, lesson).totalLessons}
        resultPreview={lesson.resultPreview}
        goodToKnowBlocks={lesson.goodToKnowBlocks}
        onExpandClick={handleExpandClick}
        onExitPreviewClick={handleExitPreviewClick}
        previewType={previewType}
        setPreviewType={setPreviewType}
        isTestMode={isTestMode}
        setTestMode={setTestMode}
      />
    </>
  );
};

export default React.memo(FigmaLessonPreviewPageContainer) as any;
